import Switch, { SwitchProps } from '@mui/material/Switch';

/**
 * Active/Inactive pill switch (Figma sources table, node 3095:52781: blue
 * checked track, light-grey unchecked track). Colors and geometry come from
 * the theme's MuiSwitch override (ported verbatim from ComplyControl's
 * adminPanelTheme.ts) — nothing else to add here.
 */
export function Toggle(props: SwitchProps) {
  return <Switch disableRipple {...props} />;
}
